let bVideoLoaded = false;

function initVideo(config, GenesysJS) {
  const video = config.deploymentConfig.video || {};
  const headlessMode = config.deploymentConfig.headlessMode || {};

  if (video.enabled === true) {
    if (!bVideoLoaded) {
      bVideoLoaded = true;
      GenesysJS.log('Video enabled. Loading VideoHelper plugin.');
      Genesys('loadPlugin', 'VideoHelper');

      if (headlessMode.enabled === true) {
        Genesys('subscribe', 'MessagingService.ready', () => {
          GenesysJS.log('Loading VideoService plugin for headless mode.');
          Genesys('loadPlugin', 'VideoService');
        });
      }
    }
  }
}

export default initVideo;
